export default __webpack_public_path__ + "static/media/headset.be4aae36.svg";